//------------------------------------------------------------------------------
// BFA10103G 共架申込 機器設備 - 地図/ポップアップ
//------------------------------------------------------------------------------
import openPolePopup from './pole-open';
import closePopup from './close-popup.js';
import { PolePopupContent, polePopupTitle } from './pole-content';

// エクスポート
export default {

  // オープン
  openPolePopup,

  // クローズ
  closePopup,

  // タイトル
  polePopupTitle,

  // ポップアップ内容
  PolePopupContent,
};
